import { createAction } from '@reduxjs/toolkit';
export const INITIALIZE_APP = 'INITIALIZE_APP';
export const initializeAppAction = createAction(INITIALIZE_APP);